import { useLocation } from 'react-router-dom'

export const PREVIEW_BASE = '/preview/campaign-flow'
export const APP_BASE = '/campaign/flow'

/**
 * The flow runs in two places: inside the signed-in app (`/campaign/flow`)
 * and as a public, no-sign-in preview (`/preview/campaign-flow`) for review
 * and QA. Links and the page frame follow whichever the user is on.
 */
export const useFlowBase = () => {
   const { pathname } = useLocation()
   const preview = pathname.startsWith(PREVIEW_BASE)
   return {
      preview,
      base: preview ? PREVIEW_BASE : APP_BASE,
      campaigns: preview ? PREVIEW_BASE : '/campaign',
   }
}
